/**
 * UI Mode (B Mode / C Mode) persistence — Doc 26 §4.
 *
 * Per-surface complexity toggle stored under `uiMode:<surface>` in
 * localStorage. Deliberately no store/hook/feature-flag architecture yet —
 * that decision is deferred (Doc 26 §4); read and write localStorage directly.
 */

export type UiMode = 'b' | 'c';

const KEY_PREFIX = 'uiMode:';

export function getStoredUiMode(surface: string): UiMode | null {
  try {
    const raw = localStorage.getItem(`${KEY_PREFIX}${surface}`);
    return raw === 'b' || raw === 'c' ? raw : null;
  } catch {
    return null;
  }
}

export function setStoredUiMode(surface: string, mode: UiMode): void {
  try {
    localStorage.setItem(`${KEY_PREFIX}${surface}`, mode);
  } catch {
    // Private-mode / quota failures degrade to session-only mode choice.
  }
}
